import { Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Span } from 'design-system/components/Text';
import { paragraphMixins } from 'design-system/mixins/text';

const IntegrationStepWrapper = styled('div')`
  max-width: 750px;
`;

const IntegrationStepHeader = styled('div')`
  ${paragraphMixins.lgBold};
  margin-bottom: ${Spacing[2]};
`;

const IntegrationStepNumber = styled(Span)`
  margin-right: ${Spacing[2]};
`;

interface IntegrationStepProps {
  title: string;
  stepNumber?: number;
  children: ReactNode;
  isRecommendedOnly?: boolean;
  dataMarketingId?: string | null;
}

const IntegrationStep = ({
  title,
  stepNumber,
  children,
  isRecommendedOnly = false,
  dataMarketingId = null,
}: IntegrationStepProps) => (
  <IntegrationStepWrapper>
    <IntegrationStepHeader data-marketing-id={dataMarketingId}>
      {stepNumber && <IntegrationStepNumber color='brand'>Step {stepNumber}</IntegrationStepNumber>}
      {title}
      {isRecommendedOnly && <Span color='secondary'> (Recommended)</Span>}
    </IntegrationStepHeader>
    {children}
  </IntegrationStepWrapper>
);

export default IntegrationStep;
